import { APP_UI_CHANGE_THEME_DARK, APP_UI_CHANGE_THEME_LIGHT } from 'constants/ActionTypes';
import { THEME_TYPE_DARK, THEME_TYPE_LITE } from 'constants/ThemeSetting';
import { fromJS } from 'immutable';

const initialState = fromJS({
  theme: localStorage.getItem('theme') ?? THEME_TYPE_LITE,
});

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case APP_UI_CHANGE_THEME_LIGHT:
      return state.set('theme', THEME_TYPE_LITE);
    case APP_UI_CHANGE_THEME_DARK:
      return state.set('theme', THEME_TYPE_DARK);
    default:
      return state;
  }
};

export default appReducer;
